import { InjectionToken } from '@angular/core';
import { StoreConfig } from '@ngrx/store';
import { IFhirResourcesState } from './+state/fhir-resource.reducer';

export const FHIR_RESOURCES_INITIAL_STATE = new InjectionToken<
  StoreConfig<IFhirResourcesState>
>('FHIR resources - initial state');
